import _slicedToArray from "/vercel/16327899/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
/**
 * React hook that returns a constant value.
 * It always returns the very first value passed to `initialState`,
 * even if it changes between re-renders.
 *
 * @param initialValue the initial value
 */

export function useConst(initialValue) {
  var _React$useState = React.useState(initialValue),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      value = _React$useState2[0];

  return value;
}